import { createSelector, Selector } from '@ngrx/store';
import { AppState } from '../appstate';
import { CompanyRecord } from '../generated/company-record.generated';
import { selectAllCompanies } from './entity-store-selectors';

export function selectCompanies() {
  return createSelector(selectAllCompanies, (c) => {
    return c.sort((a, b) => a.name.localeCompare(b.name));
  });
}

export function selectCompanyById(
  companyId: string,
): Selector<AppState, CompanyRecord | undefined> {
  return createSelector(selectAllCompanies, (c) => c.get(companyId));
}

export function selectCompanyByCompanyCode(
  companyCode: string,
): Selector<AppState, CompanyRecord | undefined> {
  return createSelector(selectAllCompanies, (companies) => {
    const result =
      companyCode != null
        ? companies.find((c) => c.companyCode.toLowerCase() === companyCode.toLowerCase())
        : undefined;
    return result;
  });
}
